import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  revenueFormHeading: {
    id: "funding-application: revenue entry heading",
    defaultMessage: "Monthly revenue",
  },
  revenueLabel: {
    id: "funding-application: revenue amount label",
    defaultMessage: "What’s your company's average revenue per month?",
  },
  revenueAmountError: {
    id: "funding-application: revenue amount is required",
    defaultMessage: "Please enter your monthly revenue.",
  },
  revenueAmountInvalidError: {
    id: "funding-application: revenue amount is invalid",
    defaultMessage: "Please enter a positive, non-zero number",
  },
  hasRetailLabel: {
    id: "funding-applicaion: has retail radio label",
    defaultMessage: "Does your company sell products offline via retail or wholesale channels? ",
  },
  percentageOfflineLabel: {
    id: "funding-application: percentage offline label",
    defaultMessage: "How much of your annual revenue comes from wholesale or offline sales?",
  },
  hasRetailError: {
    id: "funding-application: use of retail required",
    defaultMessage: "Please indicate if your company uses offline channels",
  },
  hasDropshipLabel: {
    id: "funding-applicaion: has dropship radio label",
    defaultMessage: "Does your company dropship any products? ",
  },
  percentageDropshipLabel: {
    id: "funding-application: percentage dropship label",
    defaultMessage: "What percentage of your company’s revenue comes from products that are dropshipped?",
  },
  hasDropshipError: {
    id: "funding-application: use of dropship required",
    defaultMessage: "Please indicate if your company uses dropshipping",
  },
  percentageError: {
    id: "funding-application: percentage range required",
    defaultMessage: "Please select the correct percentage of revenue",
  },
  businessModelLabel: {
    id: "funding-application: business model label",
    defaultMessage: "How would you describe your business model?",
  },
  businessModelError: {
    id: "funding-application: business model required",
    defaultMessage: "Please select a business model",
  },
  businessModelEcommerce: {
    id: "funding-application: business model ecommerce",
    defaultMessage: "Sell physical products online or through wholesale",
  },
  businessModelRetail: {
    id: "funding-application: business model retail",
    defaultMessage: "Retail or hospitality business (Restaurants, gyms, hotels, etc.)",
  },
  businessModelSaas: {
    id: "funding-application: business model saas",
    defaultMessage: "Software or digital services (SaaS)",
  },
  businessModelService: {
    id: "funding-application: business model service",
    defaultMessage: "Provide services (Legal, accounting, consulting, etc.)",
  },
  businessModelOther: {
    id: "funding-application: business model other",
    defaultMessage: "Other",
  },
});
